import React from 'react';
import { Building } from 'lucide-react';

export const RegisterLocationInfo = ({ formData, handleChange }) => (
    <div className="space-y-4">
      <h3 className="font-semibold text-gray-900 mb-4">Location & Contact Details</h3>
      
      <div>
        <label className="block text-sm font-medium mb-1.5">Full Address *</label>
        <textarea
          name="address"
          value={formData.address}
          onChange={handleChange}
          rows="2"
          className="w-full px-4 py-2 border border-[hsl(var(--border))] rounded-lg focus:outline-none focus:ring-2 focus:ring-[hsl(var(--ring))]"
          placeholder="Street address, Building name, Floor"
          required
        />
      </div>

      <div className="grid grid-cols-2 gap-4">
        <div>
          <label className="block text-sm font-medium mb-1.5">City *</label>
          <input
            name="city"
            type="text"
            value={formData.city}
            onChange={handleChange}
            className="w-full px-4 py-2 border border-[hsl(var(--border))] rounded-lg focus:outline-none focus:ring-2 focus:ring-[hsl(var(--ring))]"
            placeholder="Mumbai"
            required
          />
        </div>
        <div>
          <label className="block text-sm font-medium mb-1.5">State *</label>
          <input
            name="state"
            type="text"
            value={formData.state}
            onChange={handleChange}
            className="w-full px-4 py-2 border border-[hsl(var(--border))] rounded-lg focus:outline-none focus:ring-2 focus:ring-[hsl(var(--ring))]"
            placeholder="Maharashtra"
            required
          />
        </div>
      </div>

      <div className="grid grid-cols-2 gap-4">
        <div>
          <label className="block text-sm font-medium mb-1.5">Country</label>
          <input
            name="country"
            type="text"
            value={formData.country}
            onChange={handleChange}
            className="w-full px-4 py-2 border border-[hsl(var(--border))] rounded-lg focus:outline-none focus:ring-2 focus:ring-[hsl(var(--ring))]"
            placeholder="India"
          />
        </div>
        <div>
          <label className="block text-sm font-medium mb-1.5">Pincode</label>
          <input
            name="pincode"
            type="text"
            value={formData.pincode}
            onChange={handleChange}
            className="w-full px-4 py-2 border border-[hsl(var(--border))] rounded-lg focus:outline-none focus:ring-2 focus:ring-[hsl(var(--ring))]"
            placeholder="400001"
          />
        </div>
      </div>

      <div>
        <label className="block text-sm font-medium mb-1.5">Website</label>
        <input
          name="website"
          type="url"
          value={formData.website}
          onChange={handleChange}
          className="w-full px-4 py-2 border border-[hsl(var(--border))] rounded-lg focus:outline-none focus:ring-2 focus:ring-[hsl(var(--ring))]"
          placeholder="https://your-hospital.com"
        />
      </div>

      <div className="grid grid-cols-2 gap-4">
        <div>
          <label className="block text-sm font-medium mb-1.5">Established Year</label>
          <input
            name="established_year"
            type="number"
            value={formData.established_year}
            onChange={handleChange}
            className="w-full px-4 py-2 border border-[hsl(var(--border))] rounded-lg focus:outline-none focus:ring-2 focus:ring-[hsl(var(--ring))]"
            placeholder="1990"
          />
        </div>
        <div>
          <label className="block text-sm font-medium mb-1.5">Registration No.</label>
          <input
            name="registration_number"
            type="text"
            value={formData.registration_number}
            onChange={handleChange}
            className="w-full px-4 py-2 border border-[hsl(var(--border))] rounded-lg focus:outline-none focus:ring-2 focus:ring-[hsl(var(--ring))]"
            placeholder="MH/2020/12345"
          />
        </div>
      </div>

      <div className="grid grid-cols-3 gap-4">
        <div>
          <label className="block text-sm font-medium mb-1.5">Total Beds</label>
          <input
            name="bed_count"
            type="number"
            value={formData.bed_count}
            onChange={handleChange}
            className="w-full px-4 py-2 border border-[hsl(var(--border))] rounded-lg focus:outline-none focus:ring-2 focus:ring-[hsl(var(--ring))]"
            placeholder="500"
          />
        </div>
        <div>
          <label className="block text-sm font-medium mb-1.5">ICU Beds</label>
          <input
            name="icu_beds"
            type="number"
            value={formData.icu_beds}
            onChange={handleChange}
            className="w-full px-4 py-2 border border-[hsl(var(--border))] rounded-lg focus:outline-none focus:ring-2 focus:ring-[hsl(var(--ring))]"
            placeholder="50"
          />
        </div>
        <div>
          <label className="block text-sm font-medium mb-1.5">Doctors</label>
          <input
            name="doctors_count"
            type="number"
            value={formData.doctors_count}
            onChange={handleChange}
            className="w-full px-4 py-2 border border-[hsl(var(--border))] rounded-lg focus:outline-none focus:ring-2 focus:ring-[hsl(var(--ring))]"
            placeholder="200"
          />
        </div>
      </div>
    </div>
);
